import EnrollWrapper from '../EnrollWrapper';
import { Dispatch, SetStateAction } from 'react';
import EnrollItemSkeleton from '../EnrollItem/Skeleton';
import PerPageSkeleton from '../SharedPagination/PerPageDropdown/Skeleton';
import SharedPaginationSkeleton from '../SharedPagination/Skeleton';

export default function EnrollSkeleton({ isOpen, perPage, setIsOpen }: { isOpen: boolean; perPage: number; setIsOpen: Dispatch<SetStateAction<boolean>> }) {
  return (
    <EnrollWrapper isOpen={isOpen} paginationComponent={<SharedPaginationSkeleton />} perPage={perPage} perPageDropDownComponent={<PerPageSkeleton />} setIsOpen={setIsOpen}>
      {Array.from({ length: perPage }).map((_, index) => (
        <EnrollItemSkeleton key={index} />
      ))}
    </EnrollWrapper>
  );
}
